<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title class="dodo">أقسام المقالات</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-layout row wrap>
        <v-flex xs12 sm4>
        </v-flex>
      </v-layout>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-btn slot="activator" color="primary" dark class="dodo mb-2" @click="dialog = true">اضافة قسم جديد</v-btn>
        <v-form v-model="valid" ref="form">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      v-model="editedItem.title"
                      :rules="titleRules"
                      class="form_label"
                      label="الاسم"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="arts"
      class="elevation-1"
      :items-per-page="15"
      hide-default-footer
      disable-pagination>

      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          تعديل
        </v-icon>
        |
        <v-icon small @click="deleteItem(item)">
          حذف
        </v-icon>
      </template>
    </v-data-table>

    <v-pagination
      class="pagination"
      total-visible="20"
      v-model="page"
      color="#c7000b"
      style="position: relative; top: 20px;"
      circle=""
      :length="pageCount">
    </v-pagination>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import axios from 'axios'

export default {
  props: ['settings'],
  data() {
    return {
      errors: {},
      page: 1,
      pageCount: 0,
      current_page: 1,
      last_page: 0,

      titleRules: [
        (v) => !!v || 'يجب ادخال عنوان القسم',
      ],

      valid: false,
      dialog: false,
      arts: [],
      headers: [
        { text: 'ID', value: 'id', sortable: false },
        { text: 'الاسم', value: 'title', sortable: false, align: 'right' },
        { text: 'تاريخ الاضافة', value: 'created_at', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        title: '',
      },
      defaultItem: {
        title: '',
      },
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'أضافة قسم جديد' : 'تعديل القسم'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    page() {
      this.getMoreitems()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    getMoreitems() {
      if (this.current_page <= this.last_page) {
        this.current_page = this.page
        this.initialize()
      }
    },

    initialize() {
      axios.get('article_sections?page=' + this.current_page, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorizations: "Bearer " + this.$store.state.AdminInfo.token
        }
      }).then(d => {
        this.arts = d.data
        this.last_page = d.data.last_page
        this.pageCount = d.data.last_page
      })
    },

    editItem(item) {
      this.editedIndex = this.arts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.delete('article_sections/' + item.id, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Accept: "application/json",
              Authorizations: "Bearer " + this.$store.state.AdminInfo.token
            },
          }).then(() => {
            this.$swal.fire('Successfully', 'done', "success");
            this.initialize()
          }).catch(() => {
            swal("Failed!", "There was something wronge.", "warning");
          });
        }
      })
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        axios.put('article_sections/' + this.editedItem.id, {
          title: this.editedItem.title,
        }, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorizations: "Bearer " + this.$store.state.AdminInfo.token
          }
        }).then(() => {
          this.$swal.fire('Successfully', 'done', "success");
          this.dialog = false
          this.initialize()
        }).catch(() => {});
      } else {
        axios.post('article_sections', {
          title: this.editedItem.title,
        }, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorizations: "Bearer " + this.$store.state.AdminInfo.token
          }
        }).then(() => {
          this.$swal.fire('Successfully', 'done', "success");
          this.dialog = false
          this.initialize()
        }).catch(() => {});
      }
    },
  }
}
</script>
